import React, { memo } from 'react';

import { Divider, Text } from '@thefarmersfront/kitchen';

import { formatNumber } from '~/utils';

import styles from './TableTopField.module.scss';

type TypeTableTopField = {
  dataTotalCount?: number;
  selectedCount?: number;
  rightButton?: React.ReactNode;
};

const TableTopField = memo(({ dataTotalCount, selectedCount, rightButton }: TypeTableTopField) => {
  return (
    <div className={styles['table-top-field']}>
      <div className={styles['table-top-left-field']}>
        {dataTotalCount !== undefined && (
          <Text size="small" weight="semi-bold" color="secondary">
            총 {formatNumber(dataTotalCount)}건
          </Text>
        )}
        {selectedCount ? (
          <>
            <Divider orientation="vertical" />
            <Text size="small" weight="semi-bold" color="tertiary">
              {formatNumber(selectedCount)}건 선택
            </Text>
          </>
        ) : null}
      </div>
      <div className={styles['table-top-right-field']}>{rightButton}</div>
    </div>
  );
});

TableTopField.displayName = 'TableTopField';

export default TableTopField;
